import React from 'react'
import PropTypes from 'prop-types'

const FinishedCertImage = props => {
  return (
    <div>
      <img
        id="target"
        src={
          props.imageLoaded
            ? props.image
            : '/static/base_app/media/logos/wordmark-blue-orange-tagline-horizontal.png'
        }
        alt={props.imageName}
        style={{ maxHeight: 50, maxWidth: 250 }}
      />
    </div>
  )
}

FinishedCertImage.propTypes = {
  imageLoaded: PropTypes.bool,
  image: PropTypes.string,
  imageName: PropTypes.string,
}

export default FinishedCertImage
